(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.initSlider();
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }

    initSlider() {
      const scroller = this.querySelector('.native-scroller');
      if (!scroller) return;

      const autoSlide = this.dataset.autoSlide === 'true';
      const interval = parseInt(this.dataset.interval) * 1000;

      if (!autoSlide) return;

      // Start the interval
      this.startAutoSlide(scroller, interval);

      // Pause on hover
      scroller.addEventListener('mouseenter', () => this.stopAutoSlide());
      scroller.addEventListener('mouseleave', () => this.startAutoSlide(scroller, interval));
      
      // Also pause if user touches (mobile)
      scroller.addEventListener('touchstart', () => this.stopAutoSlide(), {passive: true});
    }

    startAutoSlide(scroller, interval) {
      this.stopAutoSlide(); // clear any existing
      this.intervalId = setInterval(() => {
        // Check if we are at the end
        if (Math.ceil(scroller.scrollLeft + scroller.clientWidth) >= scroller.scrollWidth) {
           scroller.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
           // Scroll by width of one card + gap (approx)
           const card = scroller.querySelector('.product-card-item');
           const scrollAmount = card ? card.offsetWidth + 20 : 300; 
           scroller.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      }, interval);
    }

    stopAutoSlide() {
      if (this.intervalId) clearInterval(this.intervalId);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  // Global functions for buttons
  window.scrollNative = function(id, direction) {
    var scroller = document.getElementById(id);
    if(scroller) {
      var scrollAmount = (scroller.clientWidth / 5) * direction * 2; 
      scroller.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  window.toggleRecWishlist = function(btn, productId) {
    event.stopPropagation();
    event.preventDefault();
    btn.classList.toggle('active');
    // Basic LocalStorage persistence
    let wishlist = JSON.parse(localStorage.getItem('myWishlist')) || [];
    if (btn.classList.contains('active')) {
      if(!wishlist.includes(productId)) wishlist.push(productId);
    } else {
      wishlist = wishlist.filter(id => id !== productId);
    }
    localStorage.setItem('myWishlist', JSON.stringify(wishlist));
  };

  } catch(e) { console.error(e); }
})();
})();
